module.exports = __webpack_public_path__ + "static/media/big-wave.12aa870e.svg";